import { useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import { toast } from 'sonner';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

function AuthCallback() {
  const navigate = useNavigate();
  const hasProcessed = useRef(false);
  
  useEffect(() => {
    // CRITICAL: Prevent double execution in StrictMode
    if (hasProcessed.current) return;
    hasProcessed.current = true;
    
    const processAuth = async () => {
      try {
        const hash = window.location.hash;
        const params = new URLSearchParams(hash.substring(1));
        const sessionId = params.get('session_id');
        
        if (!sessionId) {
          toast.error('Autenticación fallida');
          navigate('/login');
          return;
        }
        
        // Exchange session_id for user data
        const response = await axios.post(
          `${BACKEND_URL}/api/auth/session`,
          { session_id: sessionId },
          { withCredentials: true }
        );
        
        const user = response.data;
        
        // Navigate to dashboard with user data
        navigate('/', { replace: true, state: { user } });
        toast.success(`¡Bienvenido, ${user.name}!`);
      } catch (error) {
        console.error('Auth callback error:', error);
        // Extraer mensaje específico del backend (ej: cuenta pendiente de aprobación)
        const backendMsg = error?.response?.data?.detail;
        const status = error?.response?.status;
        if (status === 403 && backendMsg) {
          // Mostrar pantalla amigable de "cuenta pendiente"
          navigate('/login', { replace: true, state: { pendingApproval: backendMsg } });
        } else {
          toast.error(backendMsg || 'Error en la autenticación');
          navigate('/login');
        }
      }
    };
    
    processAuth();
  }, [navigate]);
  
  return (
    <div className="min-h-screen flex items-center justify-center bg-background">
      <div className="text-center">
        <div className="w-16 h-16 border-4 border-blue-600 border-t-transparent rounded-full animate-spin mx-auto mb-4"></div>
        <p className="text-sm text-muted-foreground">Autenticando...</p>
      </div>
    </div>
  );
}

export default AuthCallback;